import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useAuth } from "@/auth";
import { useEffect } from "react";

function AuthCallback() {
  const navigate = useNavigate();
  const { user, isLoading } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const provider = params.get("provider");

    // GitHub App callback — user just installed the app
    if (provider === "github") {
      const installationId = params.get("installation_id");
      if (installationId) {
        // Store installation ID for later use
        localStorage.setItem("github_installation_id", installationId);
      }
      // Redirect back to app (onboarding will detect the installation)
      window.location.href = "/?github=connected";
      return;
    }

    // WorkOS auth callback (default)
    if (!isLoading && user) {
      void navigate({ to: "/" });
    }
  }, [isLoading, user, navigate]);

  return (
    <div className="flex h-screen items-center justify-center bg-background">
      <div className="text-sm text-muted-foreground">Connecting...</div>
    </div>
  );
}

export const Route = createFileRoute("/callback")({
  component: AuthCallback,
});
